import type { FaireProductEntity } from "../../entity_types/product";

export const p_fxys2jtpqz: FaireProductEntity = {
  token: "p_fxys2jtpqz",
  type: "product",
  name: "I ❤️ Naps Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/aebd0855df85beef4a3364707d8390217ae376fb1cdc9a7d4919c7331e420467.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f84f8fc101550f3f2d74e7ff7c524864ff68c54f89ec88f4adf9ce1149167f08.jpeg",
    "https://cdn.faire.com/fastly/b26946d8d296cb2b5691a177221266cb785366638cd6fb204c714253569a0198.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/fastly/1de1b87f2c45a66916cbf1e811fe754b53485fb2aa7a4fe4b04c6604f8fb5374.jpeg",
    "https://cdn.faire.com/fastly/4a058a9edb96c998cf2092e3d2d12403e89109cdc6dc9dff62d76a610e0e1b67.jpeg",
    "https://cdn.faire.com/fastly/72661f97f217e7ac18fb7144fe9492901d1355ae504243692577d5f9be5237b3.jpeg",
    "https://cdn.faire.com/fastly/f59798338da9ce6d16fcc036402748f4225ca6b28d9a4e06486f43ea3e90159a.jpeg"
  ],
  priceDollars: 6.75,
  description: "Whether you're about catching a quick snoozely wink or you wanna corpse it out for a few days... we get you. Being asleep is just... better. But sleeping spontaneously?? 🤤\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:28:10.437Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
